import EventSessionFormPageActionTypes from '../actions/event-session-form-page-action-types';

const initialState = {
  loading: false,
  session: null,
  validationResult: null,
  eventName: null,
  eventStartDate: null,
  eventEndDate: null,
  cancellationTokenSources: new Map()
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_START:
      return {
        ...state,
        loading: true,
        validationResult: null
      };
    case EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END:
      return {
        ...state,
        loading: false,
        session: action.payload ? action.payload.session : null,
        validationResult: action.payload ? action.payload.validationResult : null,
        eventName: action.payload ? action.payload.eventName : null,
        eventStartDate: action.payload ? action.payload.eventStartDate : null,
        eventEndDate: action.payload ? action.payload.eventEndDate : null
      };
    default:
      return state;
  }
};
